import request from '@/utils/request'

export function getFDCLocalList(params) {
    return request({
        url: `/fdcauth/${params}`,
        method: 'GET'
    })
}

export function getFDCModulesList() {
    return request({
        url: `/fdcauth/fdc_modules/`,
        method: 'GET'
    })
}

export function getFDCAllList(params) {
    return request({
        url: `/fdcauth/all/${params}`,
        method: 'GET'
    })
}

export function fdcBuyAuth(data) {
    return request({
        url: '/fdcauth/buy/',
        method: 'POST',
        data
    })
}

export function fdcBuyPriceAuth(data) {
    return request({
        url: '/fdcauth/buy_price/',
        method: 'POST',
        data
    })
}

export function trailFDCLocal(data) {
    return request({
        url: '/fdcauth/trail/',
        method: 'POST',
        data
    })
}

export function FDCVerifyCode(data) {
    return request({
        url: '/fdcauth/verify_code/',
        method: 'POST',
        data
    })
}

export function FDCLocalRead(id) {
    return request({
        url: `/fdcauth/${id}/`,
        method: 'GET',
    })
}

export function FDCLocalUpdate(id, data) {
    return request({
        url: `/fdcauth/${id}/`,
        method: 'PATCH',
        data
    })
}

export function FDCLocalDelay(id) {
    return request({
        url: `/fdcauth/${id}/delay/`,
        method: 'GET'
    })
}

export function FDCLocalAdminDelay(id, data) {
    return request({
        url: `/fdcauth/${id}/admin_delay/`,
        method: 'POST',
        data
    })
}

export function FDCLocalAddModules(id, data) {
    return request({
        url: `/fdcauth/${id}/add_modules/`,
        method: 'POST',
        data
    })
}

export function FDCLocalAddModulesPrice(id, data) {
    return request({
        url: `/fdcauth/${id}/add_modules_price/`,
        method: 'POST',
        data
    })
}

export function FDCLocalRenew(id, data) {
    return request({
        url: `/fdcauth/${id}/renew/`,
        method: 'POST',
        data
    })
}

export function FDCLocalRenewPrice(id, data) {
    return request({
        url: `/fdcauth/${id}/renew_price/`,
        method: 'POST',
        data
    })
}

export function FDCLocalAddUsers(id, data) {
    return request({
        url: `/fdcauth/${id}/add_users/`,
        method: 'POST',
        data
    })
}

export function FDCLocalAddUsersPrice(id, data) {
    return request({
        url: `/fdcauth/${id}/add_users_price/`,
        method: 'POST',
        data
    })
}

export function FDCLocalTransfer(id, data) {
    return request({
        url: `/fdcauth/${id}/transfer/`,
        method: 'POST',
        data
    })
}

export function getFDCOrdersModules(id) {
    return request({
        url: `/fdcauth/${id}/orders_modules/`,
        method: 'GET'
    })
}

export function getFDCScenes(params) {
    return request({
        url: `/fdcscene/${params || ''}`,
        method: 'GET'
    })
}

export function getFDCSceneSimpleList() {
    return request({
        url: '/fdcscene/simplelist/',
        method: 'GET'
    })
}

export function createFDCScene(data) {
    return request({
        url: '/fdcscene/',
        method: 'POST',
        data
    })
}

export function updateFDCScene(id, data) {
    return request({
        url: `/fdcscene/${id}/`,
        method: 'PATCH',
        data
    })
}

export function deleteFDCScene(id) {
    return request({
        url: `/fdcscene/${id}/`,
        method: 'DELETE'
    })
}



// WEBPACK FOOTER //
// ./src/api/afFdc.js